import { Space, Tabs } from "antd";
import OneCourse from "./Tabs/OneCourse";
import ComboCourse from "./Tabs/ComboCourse";

export const Money = () => {
  const items = [
    {
      key: "2",
      label: "Combo",
      children: <ComboCourse />,
    },
    {
      key: "1",
      label: "Khóa lẻ",
      children: <OneCourse />,
    },
  ];

  return (
    <div className="container">
      <Space
        direction="vertical"
        size={"middle"}
        style={{
          width: "100%",
        }}
      >
        <div className="title">Danh sách chi phí khóa học</div>
        <Tabs items={items} />
      </Space>
    </div>
  );
};
